export default {
    CZ: {
        'label_username': 'zadejte vaše uživatelské jméno',
        'label_smscode': 'zadejte ověřovací kód ze SMS',
        'placeholder_username': 'jmeno.prijmeni - bez @tul.cz',
        'placeholder_smscode': 'zadejte ověřovací kód ze SMS - bez pomlček',
        'submit': 'odeslat',
        'label_birth': 'zadej poslední čtyři číslice z rodného čísla',
        'placeholder_birth': 'poslední čtyři číslice',
        'label_password': 'zadejte svoje nové heslo do sítě LIANE',
        'label_password2': 'heslo pro kontrolu ještě jednou',
        'placeholder_password': 'nové heslo',
        'title': 'Změna hesla do sítě LIANE pomocí SMS',
        'step1': 'Krok 1. - zadejte vaše uživatelské jméno',
        'step2': 'Krok 2. - potvrďte svou identitu',
        'step3': 'Krok 3. - zadejte ověřovací kód z SMS',
        'step4': 'Krok 4. - zvolte nové heslo'
    },
    EN: {
        'label_username': 'enter your Liane username',
        'label_smscode': 'enter the code from text message',
        'placeholder_username': 'firstname.lastname - without @tul.cz',
        'placeholder_smscode': 'enter the code from text message - without hyphens',
        'submit': 'send',
        'label_birth': 'enter last four digits from birth number',
        'placeholder_birth': 'last four digits',
        'label_password': 'enter your new LIANE password',
        'label_password2': 'repeat password for confirmation',
        'placeholder_password': 'new password',
        'title': 'Change you LIANE password with SMS',
        'step1': 'Step 1 - enter your username',
        'step2': 'Step 2 - confirm your identity',
        'step3': 'Step 3 - enter the code from SMS',
        'step4': 'Step 4 - choose your new password'
    }
};
